// ============================================
// UNIT LABELS — what to call a truck/trailer on screen
// ============================================
// One source of truth, because this went wrong in three places at once.
//
// Subbies name their trucks ("H94", "H97") far more reliably than they fill in make/model — and
// that name is what the office and the drivers actually use. So the NAME leads and the
// registration sits underneath. Never the other way round, and never a blank first line just
// because make/model happen to be empty.
//
// The real case: Absolute Logistics' fleet is unit_name "H94"/"H97" with make AND model both NULL,
// so any screen that labelled a truck with `${make} ${model}` showed an empty line.

export const unitLabel = (unit) => {
  if (!unit) return '';
  const named = unit.unit_name || unit.unit_number;
  if (named && String(named).trim()) return String(named).trim();
  const described = `${unit.make || ''} ${unit.model || ''}`.trim();
  return described || unit.registration_number || '';
};

// The registration underneath — unless the label above already IS the registration.
export const unitSubLabel = (unit) => {
  if (!unit) return '';
  return unitLabel(unit) === unit.registration_number ? '' : (unit.registration_number || '');
};
